import React, {useState, useEffect} from 'react';
import { axiosAuthFetch, axiosImageAuthFetch } from '../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../constants';
import Loader from '../../loader';
import styles from './consumable.module.css';

function AddConsumableForm() {
    const [file, setFile] = useState(null);
    const [consumableName, setConsumableName] = useState('');
    const [consumablePrice, setConsumablePrice] = useState('');
    const [consumableDescription, setConsumableDescription] = useState('');
    const [consumableVarenummer, setConsumableVarenummer] = useState('');
    const [parentProductId, setParentProductId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        async function fetchProducts() {
            try {
                const response = await axiosAuthFetch(`${API_BASE_URL}/products?pagination[pageSize]=500&sort=name:asc`);
                setProducts(response.data);
            } catch (error) {
                console.error(error);
            }
        }

        fetchProducts();
    }, []);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleConsumableNameChange = (event) => {
        setConsumableName(event.target.value);
    };

    const handleConsumableDescriptionChange = (event) => {
        setConsumableDescription(event.target.value);
    };

    const handleConsumableVarenummerChange = (event) => {
        setConsumableVarenummer(event.target.value);
    };

    const handleConsumablePriceChange = (event) => {
        setConsumablePrice(event.target.value);
    };

    const handleParentProductChange = (event) => {
        setParentProductId(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        const priceToSend = consumablePrice === '' ? null : parseFloat(consumablePrice);

        try {
            const consumableData = {
                "data": {
                    "name": consumableName,
                    "description": consumableDescription,
                    "price": priceToSend,
                    "varenummer": consumableVarenummer,
                    "type": "consumable",
                    "parent_products": [parentProductId]  // Relasjon til foreldreprodukt
                },
            };

            const consumableResponse = await axiosAuthFetch(`${API_BASE_URL}/products`, consumableData, 'post');
            const consumableID = consumableResponse.data.id;

            if (file) {
                const imageData = new FormData();
                imageData.append('ref', 'api::product.product');
                imageData.append('refId', consumableID);
                imageData.append('field', 'image');
                imageData.append('files', file);

                const imageResponse = await axiosImageAuthFetch(`${API_BASE_URL}/upload`, imageData);
                console.log(imageResponse);
            }

            setIsLoading(false);
            alert('Forbruksvare opprettet!');
            window.location.href = "/VP/admin/nettbutikk";
        } catch (error) {
            console.error('Feil ved opplasting av bilde eller innsending av skjemadata:', error);
            setIsLoading(false);
        }
    };

    return (
        <div>
            {isLoading && <Loader />}
            <div className={styles.p}>
                <h2>Opprett ny forbruksvare</h2>
            </div>
            <form className={styles.form} onSubmit={handleSubmit}>
                <input
                    className={styles.input}
                    type="text"
                    value={consumableName}
                    onChange={handleConsumableNameChange}
                    placeholder="Navn på forbruksvare"
                    required
                />
                <textarea
                    className={styles.textAreaInput}
                    type="text"
                    value={consumableDescription}
                    onChange={handleConsumableDescriptionChange}
                    placeholder="Beskrivelse av forbruksvare"
                    rows={7}
                />
                <input
                    className={styles.input}
                    type="text"
                    value={consumablePrice}
                    onChange={handleConsumablePriceChange}
                    placeholder="Pris"
                />
                <input
                    className={styles.input}
                    type="text"
                    value={consumableVarenummer}
                    onChange={handleConsumableVarenummerChange}
                    placeholder="Varenummer"
                />
                <div className='mt-3'>Tilhørende produkt</div>
                <select
                    className={styles.select}
                    value={parentProductId}
                    onChange={handleParentProductChange}
                    required
                >
                    <option value="">Velg produkt</option>
                    {products.map(product => (
                        <option key={product.id} value={product.id}>{product.attributes.name}</option>
                    ))}
                </select>
                <h3 className={styles.h3}>Produktbilde</h3>
                <input className={styles.fileInput} type="file" onChange={handleFileChange} />
                <button className={styles.button} type="submit">Opprett</button>
            </form>
        </div>
    );
}

export default AddConsumableForm;